export default {
	and_more_dates_plural: 'e mais {dates} datas',
	and_more_dates: 'e mais {dates} data',
	attend_this_face_to_face_class_at_the_address_indicated:
		'Participe dessa aula presencial no endereço indicado',
	awaiting_results: 'Aguardando resultados',
	canceled: 'Cancelado',
	check_your_availability_at_all_times_before_confirming_your_presence:
		'Verifique sua disponibilidade em todos os horários antes de confirmar sua presença.',
	class_date: 'Data da aula',
	closed: 'Apenas convidados',
	do_you_confirm_your_registration_for_the_presential_class:
		'Confirma a sua inscrição para a aula presencial {title}?',
	do_you_confirm_your_unsubscription_to_the_presential_class:
		'Confirma cancelar a inscrição para a aula presencial {title}?',
	end_time: 'Horário de término',
	event_type: 'Tipo de evento',
	finished: 'Finalizado | Finalizados',
	in_progress: 'Em progresso',
	intermission: 'Intervalo',
	live: 'Ao vivo',
	loading_presential_classes: 'Carregando aulas presenciais',
	model: 'Modelo',
	next: 'Próximas',
	no_presential_classes_are_available_at_the_moment:
		'Não há aulas presenciais disponíveis no momento',
	no_presential_classes_are_available_with_the_selected_filter:
		'Não há aulas presenciais disponíveis para o filtro selecionado',
	opened: 'Aberto',
	please_wait_for_instructor_presence_check: 'Por favor, aguarde a validação do instrutor',
	pre_scheduled: 'Pré-agendado',
	presential_class_offline: 'Aula presencial offline',
	presential_event: 'Aula presencial',
	receive_emails_about_this_presential_class: 'Receber emails sobre essa aula presencial',
	register_for_the_presential_class: 'Inscrever-se na aula presencial',
	reproved: 'Reprovado',
	scheduled: 'Agendado',
	start_time: 'Horário de início',
	subscribe: 'Inscrever',
	subscribed: 'Inscrito',
	successfully_signed_up_for_the_presential_class:
		'Inscrição feita para a aula presencial com sucesso',
	this_class_has_already_ended_finish_the_rest_of_the_days_activities:
		'Essa aula já foi finalizada. Finalize as demais atividades desse dia',
	this_class_has_already_ended: 'Essa aula já foi finalizada.',
	transmission_date: 'Data de Transmissão',
	transmission_finished: 'Transmissão Finalizada',
	unsubscribe_from_the_presential_class: 'Cancelar inscrição da aula presencial',
	unsubscribe_successfully_for_the_presential_class: 'Inscrição cancelada com sucesso',
	unsubscribe: 'Cancelar inscrição',
	you_already_have_a_certificate_for_this_type_of_event:
		'Você já possui um certificado para esse tipo de evento',
	your_presential_class_will_start_soon_please_wait:
		'Sua aula presencial irá começar em breve, por favor aguarde',
}
